import { render, staticRenderFns } from "./Experts.vue?vue&type=template&id=1a742a11"
import script from "./Experts.vue?vue&type=script&lang=js"
export * from "./Experts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports